export default () => {
    // Add script google map to the head
    const googleMapApiKey = 'AIzaSyD-DL0j1P3oJFkJbD5vGaLP-8wnoYNWQlc';
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}`
    script.setAttribute('async', '')
    script.setAttribute('defer', '')
    document.head.appendChild(script)

    // Init google map
    function initMap(lat, lng, mapElement) {
        const center = {lat, lng};
        const map = new google.maps.Map(mapElement, {
            center,
            zoom: 14,
            disableDefaultUI: true,
        });

        const marker = new google.maps.Marker({
            map,
            position: center,
            // icon: {
            //     url: '/assets/images/nordica-marker.png',
            //     scaledSize: new google.maps.Size(35, 48)
            // }
        });
    }

    // Get google map static image
    function getMapThumbnail(lat, lng, zoom = 15, width = 400, height = 400) {
        const imageUrl = 'https://www.nordica.com/assets/images/nordica-marker.png';
        return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}&markers=icon:${imageUrl}%7C${lat},${lng}&key=${googleMapApiKey}`;
    }

    // Page events list
    const eventsPage = document.querySelector('.events')
    if (eventsPage) {
        const maps = document.querySelectorAll('.google-map-event')
        maps.forEach(map => map.src = getMapThumbnail(map.getAttribute('data-lat'), map.getAttribute('data-lng')))

        function createMap(map) {
            const mapContainer = document.createElement('div')
            const loader = document.createElement('div')
            mapContainer.classList.add('mapContainer')
            mapContainer.style.height = map.getBoundingClientRect().height + 'px'
            loader.classList.add('loading')
            map.parentNode.insertBefore(mapContainer, map.nextSibling);
            map.parentNode.insertBefore(loader, map.nextSibling);

            const lat = parseFloat(map.getAttribute('data-lat'))
            const lng = parseFloat(map.getAttribute('data-lng'))
            initMap(lat, lng, mapContainer)
            map.remove()
        }

        eventsPage.addEventListener('click', (e) => {
            if (e.target.classList.contains('google-map-event')) {
                const map = e.target
                createMap(map)
            }
        })
    }

    // Page event detail
    const eventDetailPage = document.querySelector('.event-detail')
    if (eventDetailPage) {
        const map = document.getElementById('map')
        const lat = parseFloat(map.getAttribute('data-lat'))
        const lng = parseFloat(map.getAttribute('data-lng'))
        setTimeout(() => initMap(lat, lng, map), 1000)
    }
}
